import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { StoreService } from './../store.service'; 
import { Http } from '@angular/http'; 
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

import {MatAutocompleteModule} from '@angular/material/autocomplete';


@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent implements OnInit {

  constructor( private $store : StoreService,
    public http: Http,
    public afAuth: AngularFireAuth,
    public router: Router ) { }

  autoComplEl = []
  query: any

  ngOnInit() {
    $(window).scroll(function() {
      if ($(document).scrollTop() > 50) {
        $('.searchBar_cont').css('height', '62px'); 
        $('.searchBar_cont').css('opacity', '1'); 
        $('.searchBar_cont').css('background-color', '#f5f5f5'); 
        $('.searchBar_cont').css('box-shadow', '1px 1px 5px 0px #80808091'); 
        $('.searchBar_cont').css('padding-top', '12px');
        $('.searchBar_legend').css('opacity', '0');
      } else {
        $('.searchBar_cont').css('height', '73px');
        $('.searchBar_cont').css('opacity', '1'); 
        // $('.searchBar_cont').css('background-color', 'rgb(90, 90, 90)'); 
        $('.searchBar_cont').css('background-color', '#eaeaea'); 
        $('.searchBar_cont').css('box-shadow', 'rgba(58, 66, 70, 0.48) 1px 1px 5px 0px');
        $('.searchBar_cont').css('padding-top', '12px');
        $('.searchBar_legend').css('opacity', '1');
      }
    });

  }

  getCustomClass() {
    return this.$store.router.profile ? 'example-form_profilePage profile' : 'example-form_profilePage notProfile'}

  logout() {
    this.afAuth.auth.signOut().then(
      res => this.refresh()
    )
  }

  refresh() {
    this.$store.currentUser = undefined
    this.router.navigateByUrl('')
}

  toSearch() {
    this.$store.router = {
      profile : false, 
      params : null
    }
    this.$store.searchedSkills_array = []
  }

  toProfile() {
    //this.router.navigateByUrl('/profile');
    if (this.$store.router.profile) {
      this.$store.getProfile(this.$store.currentUser.email)
      this.$store.router.params = null
    }
    else {
      this.$store.router = {
        profile : true, 
        params : null
      }
    }


  }

  getAutocomplete(event) {
    this.autoComplEl = this.$store.autoComplete(event.target.value)
  }

  select(item){
    this.query = item;
    this.autoComplEl = [];
}

  

}




// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/search-bar/search-bar.component.ts